export default {
  "home": {
    "desc": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Sekaijū no shinkō oyobi shuyōna ātisuto no ongaku no taezu kakudai suru mikkusu o hakken, sutorīmingu, kyōyū shimasu."])},
    "listen": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Subarashī ongaku o kikimashou!"])},
    "songs": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Uta"])}
  },
  "manage": {
    "my_songs": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Watashi no uta"])}
  },
  "register": {
    "TOS": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["riyō kiyaku"])},
    "accept": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, list: _list } = ctx;return _normalize(["Milo Music no ", _interpolate(_list(0)), " ni dōi shimasu."])}
  },
  "song": {
    "comment_count": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named, plural: _plural } = ctx;return _plural([_normalize(["Komento wa arimasen"]), _normalize(["1 komento"]), _normalize([_interpolate(_named("count")), " komento"])])}
  }
}